import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface DashboardTopProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function DashboardTop(props: DashboardTopProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Dashboard Top"
      width={122}
      height={414}
      viewBox="0 0 122 414"
      position={{top: 44, left: 357}}
    >
      <path
        d="M121 346.899C121 355.893 96 362.388 96 373.88V394.864C96 404.357 78.6449 409.194 68 411.852C54 413.85 40 412.851 35 411.777C23.6667 390.134 1 324.672 1 239.964V207V174.036C1 89.3286 23.6667 23.8666 35 2.22354C40 1.14899 54 0.149689 68 2.14825C78.6449 4.80582 96 9.64291 96 19.136V143.046C96 163.032 99.6718 166.205 103 172.025C107 179.02 107 188.014 107 192.011V251.968C107 268.456 121 269.955 121 278.948V312.924V346.899Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M52 366C77 364 121 357 121 347V278C121 264 37.5 258 37.5 258C38.5 288 41.5 319 52 366Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M52 366C77 364 121 357 121 347V278C121 264 37 258 37 258"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M114 342V278C111 278 109 283 109 286V334.594C109 338 111 342 114 342Z"
        fill="currentColor"
        className={baseStroke()}
      />
      <path
        d="M121 343C111 343 109 339 109 332L109 310L109 288C109 281 111 277 121 277"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path
        d="M121 346.899C121 355.893 96 362.388 96 373.88V394.864C96 404.357 78.6449 409.194 68 411.852C54 413.85 40 412.851 35 411.777C23.6667 390.134 1 324.672 1 239.964V207V174.036C1 89.3286 23.6667 23.8666 35 2.22354C40 1.14899 54 0.149719 68 2.14825C78.6449 4.80585 96 9.64291 96 19.136V143.046C96 163.032 99.6718 166.205 103 172.025C107 179.02 107 188.014 107 192.011V251.968C107 268.456 121 269.955 121 278.948V312.924V346.899Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path
        d="M68 412C57 391 37.5 327 37 238V207V176C37.5 87 57 23 68 2"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M92 221V207V193L92 192.856C91.9994 186.181 91.9991 182 102 182C102 178 101 177 87 177C79.9822 177 59.6972 177.029 50 178C45.5 178.451 42 178.427 42 186V207V228C42 235.573 45.5 235.549 50 236C59.6972 236.971 79.9822 237 87 237C101 237 102 236 102 232C91.9991 232 91.9994 227.819 92 221.144L92 221Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M92 221V207V193L92 192.856C91.9994 186.181 91.9991 182 102 182C102 178 101 177 87 177C79.9822 177 59.6972 177.029 50 178C45.5 178.451 42 178.427 42 186V207V228C42 235.573 45.5 235.549 50 236C59.6972 236.971 79.9822 237 87 237C101 237 102 236 102 232C91.9991 232 91.9994 227.819 92 221.144L92 221Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path
        d="M97 230.985V183C93 183 92 186.999 92 188.998V223.987C92 229.985 95.3333 231.152 97 230.985Z"
        fill="currentColor"
        className={baseStroke()}
      />
      <path
        d="M102 232.099V207V181.901"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path d="M94 184L44 180" stroke="currentColor" className={baseStroke()} />
      <path d="M94 230L44 234" stroke="currentColor" className={baseStroke()} />
      <rect
        x="11"
        y="157"
        width="16"
        height="100"
        rx="8"
        fill="currentColor"
        className={cn(baseFill())}
      ></rect>
      <rect
        x="11"
        y="157"
        width="16"
        height="100"
        rx="8"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path
        d="M19 257C19 217.922 19 195.947 19 157"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M15 256C15 219.042 15 194.961 15 158"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M23 256C23 216.924 23 196.953 23 158"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 183C22.5021 183 15.5342 183 27 183"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 199C22.5021 199 15.5342 199 27 199"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 167C22.5021 167 15.5342 167 27 167"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 231C22.5021 231 15.5342 231 27 231"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 247C22.5021 247 15.5342 247 27 247"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M11 215C22.5021 215 15.5342 215 27 215"
        stroke="currentColor"
        className={baseStroke()}
      />
      <circle cx="52" cy="52" r="15" fill="currentColor" className={cn(baseFill())}></circle>
      <circle
        cx="52"
        cy="52"
        r="15"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="52" cy="52" r="11" stroke="currentColor" className={baseStroke()} />
      <circle cx="52" cy="52" r="2" stroke="currentColor" className={baseStroke()} />
      <circle cx="52" cy="362" r="15" fill="currentColor" className={cn(baseFill())}></circle>
      <circle
        cx="52"
        cy="362"
        r="15"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <circle cx="52" cy="362" r="11" stroke="currentColor" className={baseStroke()} />
      <circle cx="52" cy="362" r="2" stroke="currentColor" className={baseStroke()} />
    </PartSvg>
  );
}
